import React, { useContext } from 'react';

import { CartFilled } from '@zooplus/icons';
import { ButtonAnchor, CartButton, NumberBadge } from '@zooplus/ui-components';

import AppContext from '../../context';

import styles from './CartNavButton.module.scss';

const CART_URL = '/checkout/cart';

const navigateToCart = () => {
    window.location.assign(CART_URL);
};

const CartCounter = ({ cartCount }: { cartCount: number }) => {
    return (
        <>
            {cartCount > 0 && (
                <NumberBadge
                    amount={cartCount}
                    data-zta="header-cart-nav-counter"
                    variant="neutral"
                    aria-hidden="true"
                    className={styles.cartCounter}
                />
            )}
        </>
    );
};

export const CartNavButton = (): JSX.Element => {
    const { cart, translations } = useContext(AppContext);

    const cartCount = cart.summary.articleCount;

    return (
        <>
            <ButtonAnchor
                variant="cart"
                className={styles.cartAnchorButton}
                href={CART_URL}
                data-zta="header-cart-nav-anchor"
                id="header-cart-nav-anchor">
                <CartFilled aria-hidden="true" />
                <span>
                    {translations.get('shop.header.cart-nav.button.label')}
                </span>
                <CartCounter cartCount={cartCount} />
            </ButtonAnchor>
            <CartButton
                withIcon
                data-zta="header-cart-nav-button"
                className={styles.cartButton}
                size="small"
                aria-labelledby="header-cart-nav-anchor"
                onClick={navigateToCart}>
                <CartCounter cartCount={cartCount} />
            </CartButton>
        </>
    );
};
